import blog1 from '../images/blogs/blog1.jpg';
import blog2 from '../images/blogs/blog2.jpg';
import blog3 from '../images/blogs/blog3.jpg';
import blog4 from '../images/blogs/blog4.jpg';


const blogs = [
    
    {
        id: 2,
        image: blog2,
        title: 'Node.js fs Module',
        link: 'https://anuragtomar.hashnode.dev/nodejs-file-system-module',
        date : '12',
        month: 'Sep',
        year: '2021'
    },
    {
        id: 3,
        image: blog3,
        title: 'Node.js Events',
        link: 'https://anuragtomar.hashnode.dev/nodejs-events',
        date : '19',
        month: 'Sep',
        year: '2021'
    },
    {
        id: 4,
        image: blog4,
        title: 'Node.js HTTP Module',
        link: 'https://anuragtomar.hashnode.dev/nodejs-http-module',
        date : '12',
        month: 'Sep',
        year: '2021'
    },

    {
        id: 1,
        image: blog1,
        title: 'ReactJS useState Hook',
        link: 'https://anuragtomar.hashnode.dev/reactjs-usestate-hook',
        date : '25',
        month: 'Jul',
        year: '2021'
    },
];

export default blogs;